/**
 * Zuschuss der Krankenkasse zum Mutterschaftsgeld pro Kalendertag (§ 24i SGB V).
 * Der Arbeitgeber zahlt die Differenz zum durchschnittlichen Nettoentgelt pro Kalendertag.
 */
export const MutterschaftsgeldKalendertag = 13;

/**
 * Das durchschnittliche Nettoentgelt wird für den Mutterschutzlohn immer auf 30 Kalendertage umgelegt.
 */
export const MutterschutzKalendertageMonat = 30;

/**
 * Schutzfrist vor der Entbindung in Wochen (§ 3 Abs. 1 MuSchG).
 */
export const SchutzfristVorEntbindungWochen = 6;

/**
 * Schutzfrist nach der Entbindung in Wochen (§ 3 Abs. 2 MuSchG).
 */
export const SchutzfristNachEntbindungWochen = 8;

/**
 * Verlängerte Schutzfrist nach der Entbindung bei besonderen Geburten
 * (Frühgeburt, Mehrlinge, Kind mit Behinderung) in Wochen.
 */
export const SchutzfristNachEntbindungBesondereWochen = 12;
